import { css } from 'styled-components'

import {
  defineFont,
  Font,
  FontStyles,
  FontWeights,
  FontSourceFormat,
} from '../utils/FontUtils'

const fontFaceSrc = (d: Font): { url: string; format: string } => {
  const stem = d.fileBasename ?? d.basename
  const fmt: FontSourceFormat = d.sourceFormat ?? 'woff2'
  if (fmt === 'truetype') {
    return { url: `/fonts/${d.basename}/${stem}.ttf`, format: 'truetype' }
  }
  return { url: `/fonts/${d.basename}/${stem}.woff2`, format: 'woff2' }
}

enum FontKeys {
  UniversRoman = 'UniversRoman',
  UniversCondensed = 'UniversCondensed',
  UniversBoldCondensed = 'UniversBoldCondensed',
}

export const declarations: { [key in FontKeys]: Font } = {
  UniversRoman: {
    basename: 'BbComputer',
    fileBasename: 'BB-Regular',
    sourceFormat: 'truetype',
    fontFamily: 'BB Computer',
    fontWeight: FontWeights.regular,
    fontStyle: FontStyles.normal,
    fallback: 'Arial, Helvetica, sans-serif',
  },
  UniversCondensed: {
    basename: 'BbComputer',
    fileBasename: 'BB-Cond',
    sourceFormat: 'truetype',
    fontFamily: 'BB Computer Condensed',
    fontStyle: FontStyles.normal,
    fontWeight: FontWeights.regular,
    fallback: 'Arial, Helvetica, sans-serif',
  },
  UniversBoldCondensed: {
    basename: 'BbComputer',
    fileBasename: 'BB-CondBold',
    sourceFormat: 'truetype',
    fontFamily: 'BB Computer Condensed Bold',
    fontStyle: FontStyles.normal,
    fontWeight: FontWeights.regular,
    fallback: 'Arial, Helvetica, sans-serif',
  },
}

export const fontsFaces: any[] = Object.values(declarations)?.map((declaration) => {
  const { url, format } = fontFaceSrc(declaration)
  return css`
    @font-face {
      font-family: "${declaration.fontFamily}";
      font-style: normal;
      font-display: swap;
      font-weight: ${declaration.fontWeight};
      src: url('${url}') format('${format}');
    }
  `
})

const fonts: { [key in FontKeys]: string } = {
  UniversRoman: defineFont(declarations.UniversRoman),
  UniversCondensed: defineFont(declarations.UniversCondensed),
  UniversBoldCondensed: defineFont(declarations.UniversBoldCondensed),
}

export default fonts
